module.exports = __webpack_public_path__ + "static/media/IMG_0521.f243d2c0.jpg";